import { IPageSectionFields } from '../../../types/@types/generated/contentful';

const orientedMediaToCompatibleProps = ({
  orientedMedia,
  image,
  settings,
}: Pick<IPageSectionFields, 'orientedMedia' | 'image' | 'settings'>) => {
  return {
    image: orientedMedia?.fields.imageLandscape || orientedMedia?.fields.imagePortrait || image,
    imageLandscape: orientedMedia?.fields.imageLandscape,
    imagePortrait: orientedMedia?.fields.imagePortrait,
    videoIdLandscape:
      orientedMedia?.fields.videoIdLandscape || (settings?.video?.landscape as number | undefined),
    videoIdPortrait:
      orientedMedia?.fields.videoIdPortrait || (settings?.video?.portrait as number | undefined),
    fixedHeight:
      orientedMedia?.fields.fixedHeight || (settings?.fixedMediaHeight as boolean | undefined),
    dynamicHeight:
      orientedMedia?.fields.dynamicHeight || (settings?.dynamicMediaHeight as boolean | undefined),
    maxWidth: orientedMedia?.fields.maxWidth,
    lottieAnimationDesktop:
      orientedMedia?.fields.lottieAnimationDesktop ||
      (settings?.lottieAnimationDesktop as string | undefined),
    lottieAnimationMobile:
      orientedMedia?.fields.lottieAnimationMobile ||
      (settings?.lottieAnimationMobile as string | undefined),
  };
};

export default orientedMediaToCompatibleProps;
